import store from "@/store/";
import inscriptionService from "@/services/inscriptionService";
import haugazelService from "@/services/haugazelService";
import geoService from "@/services/geoService";
import moment from 'moment'

export default async ({ from, to, next }) => {
  if (to.path == '/prefill') {
    return next()
  }

  let possibleQueries = {
    pro: "is_residential",
    lang: "language",
    entreprise: "company_name",
    fjuridique: "legal_form",
    assujeti: "vat_application",
    bce: "vat_number",
    civilite: "civility",
    nom: "last_name",
    prenom: "first_name",
    tel: "phone",
    mobile: "mobile",
    email: "email",
    type_adresse: "scenario",
    travauxvide: "empty_house",
    temporaire: "is_temporary_offer",
    facture_freq: "payment_frequency",
    naissance: "birth_date",
    cat_client: "customer_category",
    cp: "post_code",
    confirmationId: "",
    electricite: "has_elec",
    gaz: "has_gas",
    elec_ean: "elec_ean",
    gaz_ean: "gas_ean",
    elec_fournisseur: "elec_previous_provider",
    gaz_fournisseur: "gas_previous_provider",
    elecOffre: "elec_product_id",
    gazOffre: "gas_product_id",
    elecDuree: "elec_duration",
    gazDuree: "gas_duration",
    codePromo: "promo",
    codeAgent: "agent",
    refAgent: "agent_custom_id",
    refAgentElectricity: "elec_custom_id",
    refAgentGas: "gas_custom_id",
    campagne: "campaign",
    parrain: "sponsor_customer_id",
    gas_is_green: "gas_is_green",
    elecInstalmentAmount: "elec_instalment_amount",
    gasInstalmentAmount: "gas_instalment_amount"
  };

  const payment_frequency = {
    1: "monthly",
    3: "quarterly",
    12: "yearly"
  };

  let payload = {};
  let tmpOffer = null;
  let bxAllowedTmp = null;

  for (let query in to.query) {
    if (possibleQueries[query] !== undefined) {
      if(to.path !== '/get') {
        next({path: '/get', query: to.query});
      } else {
        let value = to.query[query].trim();

        if (query === "tel" || query === "mobile") {
          let mobile = value.match("^((\\+|00|)32\\s?|0|)4(5[56]|60|[6789]\\d)(\\s?\\d{2}){3}$");
          let fix = value.match("^((\\+|00|)32\\s?|0|)(\\d(\s)?\\d{3}|\\d{2}(\s)?\\d{2})((\\s)?\\d{2}){2}$");

          if(mobile) {
            query = "mobile"
            value = "+32" + value.replace(mobile[1], "");
          }
          else if(fix) {
            query = "tel"
            value ="+32" + value.replace(fix[1], "");
          } else {
            value = null;
          }
        }

        if (query === "civilite" && !isNaN(value)) {
          let parameters = await haugazelService.getParameters();
          let civility = parameters.civilities.find(item => item.id === value);

          value = civility ? civility.code : null
        }

        if (query === "lang") value = value.toLowerCase().substring(0, 2);

        if (query === "cp") {
          let response = await geoService.getProviders(value);
          if(response.region !== 'bx') payload['city'] = response.towns[0]
          else value = null
        }

        if (query === "naissance") value = moment(value, ['DD-MM-YYYY', 'YYYY-MM-DD']).format('YYYY/MM/DD');
        if (query === "pro") value = value && value === 0 ? 1 : 0;
        if (query === "type_adresse") value = value === "1" ? "switch" : "move";
        if (query === "facture_freq")
          value =
            payment_frequency[value] != undefined
              ? payment_frequency[value]
              : "quarterly";
        if (query === "elec_duration" || query === "gas_duration")
          value = value / 12;

        if (query === "elecInstalmentAmount" || query === "gasInstalmentAmount") {
          value = parseFloat(value.replace(',', '.'));
          if(isNaN(value) ||
            to.query['codeAgent'] === undefined || 
          (query === "elecInstalmentAmount" && to.query['elecOffre'] === undefined) || 
          (query === "gasInstalmentAmount" && to.query['gazOffre'] === undefined)) {
            value = null;
          }
        }

        if ((query === "elec_fournisseur" || query === "gaz_fournisseur") && isNaN(value)) {
          let parameters = await haugazelService.getParameters();
          let provider = null;
          if(query === "elec_fournisseur") {
            provider = parameters.providers.electricity.find(provider => provider.code === value);
          } else if(query === "gaz_fournisseur") {
            provider = parameters.providers.gas.find(provider => provider.code === value);
          }

          value = provider ? provider.id : null
        }

        if (query === "elecOffre" || query === "gazOffre") {
          try {
            let response = await haugazelService.getProductByOffer(value);

            if(response && response.product) {
              let bxAllowedOffer = ["201", "202"];

              if(bxAllowedOffer.indexOf(value) >= 0 && bxAllowedTmp !== false) {
                store.commit("common/setBxAllowed", true);
                console.log('bx allowed');
              } else {
                store.commit("common/setBxAllowed", false);
                bxAllowedTmp = false;
                console.log('bx not allowed');
              }

              if(response.product.energy === "electricity") {
                payload["has_elec"] = 1;
                payload["elec_product_id"] = response.product.hgzId;
                payload["elec_is_forced_product"] = 1;
                payload["elec_duration"] = response.product.duration;
                store.commit('offer/setForcedElecProduct', response)

                if((tmpOffer && response.product.range !== tmpOffer.product.range) || !tmpOffer) {
                  payload["gas_product_id"] = response.pairedOffer.product.hgzId;
                  payload["gas_is_forced_product"] = 1;
                  payload["gas_duration"] = response.pairedOffer.product.duration;
                  store.commit('offer/setForcedGasProduct', response.pairedOffer)
                }
              } else if(response.product.energy === "gas") {
                payload["has_gas"] = 1;
                payload["gas_product_id"] = response.product.hgzId;
                payload["gas_is_forced_product"] = 1;
                payload["gas_duration"] = response.product.duration;
                store.commit('offer/setForcedGasProduct', response)

                if((tmpOffer && response.product.range !== tmpOffer.product.range) || !tmpOffer) {
                  payload["elec_product_id"] = response.pairedOffer.product.hgzId;
                  payload["elec_is_forced_product"] = 1;
                  payload["elec_duration"] = response.pairedOffer.product.duration;
                  store.commit('offer/setForcedElecProduct', response.pairedOffer)
                }
              }

              tmpOffer = tmpOffer ? tmpOffer : response;
            }
          } catch(error) {
            console.log(error.response.data)
          }
        } else {
          if(value !== null) payload[possibleQueries[query]] = value;
        }
      }
    }
  }

  if (Object.keys(payload).length) {
    console.log('middleware - tempGet');
    try {
      await store.dispatch("subscription/createSubscription");
      await store.dispatch("contract/createContract");

      let subID = store.state.subscription.id;
      let subGuid = store.state.subscription.guid;
      let contractID = store.state.contract.id;

      payload["url"] = encodeURI(window.location.href);

      await inscriptionService.updateSubscription(payload);
      await inscriptionService.updateContract(contractID, payload);

      next(`/${subID}/${subGuid}`);
    } catch (error) {
      console.log(error);
    }
  }

  return next();
};



// WEBPACK FOOTER //
// ./src/router/middleware/tempGet.js